export default "__VITE_ASSET__BHPaxyCj__"